import React, { useState, useCallback, useEffect } from "react";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { debounce } from "lodash";
import { useNavigate, useLocation } from "react-router-dom";
import { svgRatifiedBase64 } from "../../Constants/config";
import { useToast } from "../../Utils/toastContext";
import DocumentPreview from "../Create-Investment/documentpreview";
import CountryDistribution from "./country-option";
import AMLContent from "./aml-content";
import { useSelector, useDispatch } from "react-redux";
import {
  clearIsBusiness,
  clearRoleName,
  clearUserStatus,
  setEDDStatus,
  setSurveyStatus,
  setUserStatus,
  setAuthInitialized,
} from "../../Redux/store/userSlice";
import CountryPercentageField from "./country-percent";
export default function UserQuestionnaire({
  customerName,
  apidata,
  rawResponses,
  isPending,
  heading,
  eddId,
  afterSubmit,
  overallRisk,
}) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userStatus = useSelector((state) => state.user.userStatus);
  const hasPendingEDD = useSelector((state) => state.user.eddStatus);
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);
  const location = useLocation();
  const roleName = useSelector((state) => state.user.roleName);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [isHidden, setIsHidden] = useState(false);
  const [preSelectedQuestionType, setPreSelectedQuestionType] = useState({});

  // User answers
  const [answers, setAnswers] = useState({});

  // Handlers
  const handleRadioChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };

  const handleSelectChange = (questionId, value) => {
    setAnswers({ ...answers, [questionId]: value });
  };
  const handlePercentBlur = (questionId, optionId, value) => {
    let numberValue = parseFloat(value);

    if (isNaN(numberValue)) numberValue = 0;

    // Keep the numeric value in state
    handleCheckboxWithPercentChange(
      questionId,
      optionId,
      "percent",
      numberValue,
    );
  };

  const handlePercentChange = (questionId, optionId, value) => {
    const numericValue = value === "" ? "" : parseFloat(value);
    handleCheckboxWithPercentChange(
      questionId,
      optionId,
      "percent",
      numericValue,
    );
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleCheckboxChange = (questionId, optionIndex) => {
    const prev = answers[questionId] || [];
    const exists = prev.includes(optionIndex);
    const updated = exists
      ? prev.filter((i) => i !== optionIndex)
      : [...prev, optionIndex];
    setAnswers({ ...answers, [questionId]: updated });
  };

  const handleCheckboxWithPercentChange = (
    questionId,
    optionId,
    field,
    value,
  ) => {
    setAnswers((prev) => {
      const prevList = prev[questionId] || [];

      const existingIndex = prevList.findIndex((x) => x.id === optionId);

      let updatedList;

      if (existingIndex === -1) {
        updatedList = [
          ...prevList,
          {
            id: optionId,
            checked: field === "checked" ? value : false,
            percent: field === "percent" ? value : "",
          },
        ];
      } else {
        updatedList = prevList.map((item, idx) => {
          if (idx !== existingIndex) return item;

          const updated = { ...item };

          if (field === "checked") {
            updated.checked = value;

            if (!value) updated.percent = "";
          }

          if (field === "percent") {
            updated.percent = value;
            updated.checked = value !== "" ? true : updated.checked;
          }

          return updated;
        });
      }

      return {
        ...prev,
        [questionId]: updatedList,
      };
    });
  };
  const formatAnswersPayload = (answers) => {
    return {
      answers: Object.keys(answers).map((qId) => {
        const value = answers[qId];

        let formattedValue;

        // 1. Array of strings
        if (Array.isArray(value) && typeof value[0] === "string") {
          formattedValue = value;
        }

        // 2. Object (dropdown / single select)
        else if (value && typeof value === "object" && !Array.isArray(value)) {
          // File case
          if (value.file) {
            formattedValue = {
              file_id: value.file.file_id,
              file_name: value.file.file_name,
            };
          } else {
            formattedValue = {
              id: value.id,
              label: value.label,
            };
          }
        }

        // 3. Array of objects (checkbox with percent)
        // 3. Array of objects (checkbox / percent / country distribution)
        else if (Array.isArray(value) && typeof value[0] === "object") {
          // ✅ TYPE 9: Country distribution
          if (value[0]?.option) {
            formattedValue = value.map((item) => ({
              option: {
                id: item.option.id,
                label: item.option.label,
              },
              percent: Number(item.percent),
            }));
          }

          // fallback (checkbox with percent old logic)
          else {
            formattedValue = value
              .filter((item) => item.checked)
              .map((item) => ({
                id: item.id,
                percent: item.percent,
              }));
          }
        }

        // 4. Simple string
        else {
          formattedValue = value;
        }

        return {
          question_key: Number(qId),
          value: formattedValue,
        };
      }),
    };
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let c = answers;
    let x = eddId;
    let apiUrl = `${BASE_URL}/api/v1/agency/surveys/${eddId}/submit`;
    let bodyData = formatAnswersPayload(answers);
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmit = async () => {
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 200) {
        toastMessage = { message: response.message, type: "success" };
        dispatch(setSurveyStatus(false));
        navigate("/");
      } else {
        toastMessage = { message: response.message, type: "error" };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: "error" };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const downloadPDF = useCallback(
    debounce((e) => {
      setIsHidden(true);
    }, 1000), // Debounce time
    [], // Dependencies
  );
  const handleContinue = () => {
    setLoading(true);
    downloadPDF();
  };
  const mapQuestionType = (typeName) => {
    switch (typeName?.toLowerCase()) {
      case "text":
        return 1;
      case "radio":
        return 2;
      case "select":
        return 3;
      case "checkbox":
        return 4;
      case "checkbox_with_percent":
      case "checkboxwithpercent":
        return 5;
      case "countries_with_percent":
        return 9;
      default:
        return 1;
    }
  };
  const validateCountryDistribution = (answer, questionLabel) => {
    if (!answer || !Array.isArray(answer) || answer.length === 0) {
      showToast(
        `Please add at least one country for: "${questionLabel}"`,
        "error",
      );
      return false;
    }

    // Check Australia exists
    const hasAustralia = answer.some(
      (item) => item.option?.label?.toLowerCase() === "australia",
    );

    if (!hasAustralia) {
      showToast(`Australia must be included in: "${questionLabel}"`, "error");
      return false;
    }

    // Check empty / invalid rows
    const invalidRow = answer.some(
      (item) =>
        !item.option?.id ||
        !item.option?.label ||
        item.percent === "" ||
        item.percent === null ||
        Number(item.percent) <= 0,
    );

    if (invalidRow) {
      showToast(
        `Please complete all country entries in: "${questionLabel}"`,
        "error",
      );
      return false;
    }

    // Check total = 100%
    const total = answer.reduce(
      (sum, item) => sum + Number(item.percent || 0),
      0,
    );

    if (total !== 100) {
      showToast(
        `Total percentage must be 100% for: "${questionLabel}". Current: ${total}%`,
        "error",
      );
      return false;
    }

    return true;
  };
  const validateAnswers = () => {
    for (let q of questions) {
      if (q.required) {
        const answer = answers[q.id];

        // TEXT
        if (
          q.type.value === 1 &&
          (!answer || answer.toString().trim() === "")
        ) {
          showToast(`Please answer: "${q.question}"`, "error");
          return false;
        }

        // RADIO
        if (q.type.value === 2 && !answer) {
          showToast(`Please select an option for: "${q.question}"`, "error");
          return false;
        }

        // SELECT
        if (q.type.value === 3 && (!answer || !answer.id)) {
          showToast(`Please select a value for: "${q.question}"`, "error");
          return false;
        }

        // CHECKBOX
        if (q.type.value === 5 && (!answer || answer.length === 0)) {
          showToast(
            `Please select at least one option for: "${q.question}"`,
            "error",
          );
          return false;
        }

        // CHECKBOX WITH PERCENT
        if (q.type.value === 4) {
          if (
            !answer ||
            !Array.isArray(answer) ||
            answer.filter((item) => item.checked).length === 0
          ) {
            showToast(
              `Please select at least one option for: "${q.question}"`,
              "error",
            );
            return false;
          }

          const invalidPercent = answer.some(
            (item) =>
              item.checked &&
              (item.percent === undefined || item.percent === ""),
          );
          if (invalidPercent) {
            showToast(
              `Please enter percent values for all selected options in: "${q.question}"`,
              "error",
            );
            return false;
          }
        }

        // FILE
        if (q.type.value === 8 && (!answer || !answer.file)) {
          showToast(`Please upload a file for: "${q.question}"`, "error");
          return false;
        }
        if (q.type.value === 9) {
          const answer = answers[q.id];

          if (!validateCountryDistribution(answer, q.question)) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const formatLabel = (str) => str?.charAt(0).toUpperCase() + str?.slice(1);

  const questionsHtml = apidata
    ?.map((group) => {
      const groupHeader = `
      <div style="margin-bottom:12px; display:flex; justify-content:space-between; align-items:center;">
        <div style="font-size:12px;">
          <span class="name-label font-medium">Requested By:</span> ${group.requestedBy || "-"}
        </div>
        <div style="font-size:10px; color:#666;">
          ${group.respondedAt || ""}
        </div>
      </div>
    `;

      const questionsBlock = group.questions
        ?.map((q) => {
          let optionsHtml = "";

          // ✅ TEXT
          if (q.type.value === 1) {
            optionsHtml = `
            <div class="answer-box">${q.answer?.value || ""}</div>
          `;
          }

          // ✅ RADIO
          if (q.type.value === 2) {
            optionsHtml = (q.options || [])
              .map(
                (opt) => `
              <div class="option">
                <span class="circle ${
                  q.answer?.value === opt.value ? "checked" : ""
                }"></span>
                <span>${opt.label}</span>
              </div>
            `,
              )
              .join("");
          }

          // ✅ SELECT
          if (q.type.value === 3) {
            optionsHtml = `
            <div class="answer-box">
              ${q.answer?.value?.value || ""}
            </div>
          `;
          }

          // ✅ CHECKBOX
          if (q.type.value === 5 || q.type.value === 6) {
            optionsHtml = (q.options || [])
              .map(
                (opt) => `
              <div class="option">
                <span class="checkbox ${
                  (q.answer?.value || []).includes(opt.value) ? "checked" : ""
                }"></span>
                <span>${opt.label}</span>
              </div>
            `,
              )
              .join("");
          }

          // ✅ CHECKBOX WITH PERCENT
          if (q.type.value === 4) {
            optionsHtml = (q.options || [])
              .map((opt) => {
                const userOpt =
                  (q.answer?.value || []).find((a) => a.id === opt.id) || {};

                return `
                <div class="option percent-row">
                  <span class="checkbox ${userOpt.id ? "checked" : ""}"></span>
                  <span class="percent-label">${opt.label}</span>
                  <span class="percent-value">
                    ${userOpt.percent ? userOpt.percent + "%" : ""}
                  </span>
                </div>
              `;
              })
              .join("");
          }

          // ✅ FILE
          if (q.type.value === 8 && q.answer?.file) {
            optionsHtml = `
            <div class="answer-box">
              ${q.answer.file.file_name}
            </div>
          `;
          }

          return `
          <div class="question-card">
            <div class="question">
              ${q.id}. ${q.question}
            </div>
            <div class="options">
              ${optionsHtml}
            </div>
          </div>
        `;
        })
        .join("");

      return `
      <div style="margin-bottom:25px;">
        ${groupHeader}
        ${questionsBlock}
      </div>
    `;
    })
    .join("");
  const handleDownloadPDF = async () => {
    const fullHtml = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>

<style>

@page{
  size:A4;
  margin:30px;
}

body{
  font-family:sans-serif;
  margin:0;
  padding:0;
  background:#ffffff;
}

.header{
  border-bottom:2px solid #eee;
  padding-bottom:12px;
  margin-bottom:25px;
}
.font-medium{
  font-weight:500;
}
/* Center logo */
.logo-row{
  text-align:center;
  margin-bottom:10px;
}

.logo{
  height:40px;
  width:auto;
}

/* Customer + Date row */
.info-row{
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.title{
  font-size:14px;
}

.date{
  font-size:10px;
  color:#666;
}

.question-card{
  border:1px solid #e5e7eb;
  border-radius:8px;
  padding:16px;
  margin-bottom:18px;
  page-break-inside:avoid;
}

.question{
  font-size:12px;
  margin-bottom:10px;
}
  .name-label{
  color:#666}

.options{
  margin-left:5px;
}

.option{
  display:flex;
  align-items:center;
  gap:10px;
  margin-bottom:6px;
  font-size:11px;
}

.circle{
  width:12px;
  height:12px;
  border-radius:50%;
    background: #444;
}

.circle.checked{
  background:#375AE7;
  border-color:#375AE7;
}

.checkbox {
  width: 14px;
  height: 14px;
    background: #444;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
  display: inline-block;
}

.checkbox.checked{
  background:#375AE7;
  border-color:#375AE7;
}
  .checkbox.checked::after {
  content: "";
  position: absolute;
  left: 3px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
    border-radius: 2px;

  transform: rotate(45deg);
}


.answer-box{
  border:1px solid #ddd;
  padding:8px 10px;
  border-radius:4px;
  font-size:11px;
}

.percent-row{
  justify-content:space-between;
}

.percent-label{
  flex:1;
}

.percent-value{
  width:60px;
  text-align:right;
  font-weight:500;
}

.footer{
  margin-top:40px;
  text-align:center;
  font-size:10px;
  color:#777;
}

</style>
</head>

<body>

<div class="header">
  
  <!-- Logo Row -->
  <div class="logo-row">
    <img src="${svgRatifiedBase64}" alt="Logo" class="logo" />
  </div>

  <!-- Info Row -->
  <div class="info-row">
    <div class="title"><span class="name-label">Customer Name: </span>${customerName}</div>
    <div class="date">${new Date().toLocaleDateString()}</div>
  </div>

</div>

${questionsHtml}

<div class="footer">
Generated by Ratified System
</div>

</body>
</html>
`;

    //const token = localStorage.getItem("jwtToken");
    const token =
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjo1OTQsInJvbGUiOiJjdXN0b21lciIsInByZXZpb3VzX3VzZXJfaWQiOm51bGwsImNsaWVudF9pZCI6IkNNMDAyMzM0OFAiLCJleHAiOjE3NzYwODYyNjV9.JCXgyJbU8OonMEHZXcGN-PRs8UUUrsFB-BD9Ng-k01M";
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `https://demoapi.pwa.caprock.com.au/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      },
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Risk-Assessment-Questionnaire.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  useEffect(() => {
    setQuestions(apidata || []);
  }, [apidata, isPending]);

  // Build responses for AMLContent. Prefer rawResponses from API which contains
  // full question objects (with `question_code`, `answer.option_codes`, etc).
  // Fallback: if `apidata` is already grouped (has `questions`) use that,
  // otherwise if `apidata` is a flat list of question objects use it directly.
  const responsesForAML = (() => {
    if (Array.isArray(rawResponses) && rawResponses.length > 0) {
      // rawResponses appears to be the API `data` array (each item has `questions`)
      return rawResponses.flatMap((r) => r.questions || []);
    }

    if (Array.isArray(apidata) && apidata.length > 0) {
      // grouped form: array of groups with `questions`
      if (apidata[0] && Array.isArray(apidata[0].questions)) {
        return apidata.flatMap((g) => g.questions || []);
      }

      // otherwise assume apidata is already a flat list of question objects
      return apidata;
    }

    return [];
  })();
  useEffect(() => {
    if (!isPending) {
      if (!questions || questions.length === 0) return;

      const formatted = {};

      questions.forEach((q) => {
        const ans = q.answer?.value;

        if (!ans) return;

        // TEXT / RADIO
        if (q.type.value === 1 || q.type.value === 2) {
          formatted[q.id] = ans;
        }

        // SELECT
        else if (q.type.value === 3) {
          formatted[q.id] = { id: ans.id, label: ans.label }; // already {id, label}
        }

        // CHECKBOX / MULTI SELECT
        else if (q.type.value === 5 || q.type.value === 6) {
          formatted[q.id] = ans; // array of strings
        }

        // CHECKBOX WITH PERCENT
        else if (q.type.value === 4) {
          formatted[q.id] = ans.map((item) => ({
            id: item.id,
            checked: true,
            percent: item.percent,
          }));
        }

        // FILE
        else if (q.type.value === 8) {
          formatted[q.id] = {
            file: {
              file_id: q.answer.file.file_id,
              file_name: q.answer.file.file_name,
              s3_path: q.answer.file.s3_path,
              presigned_url: q.answer.file.presigned_url,
            },
          };
        } else if (q.type.value === 9) {
          formatted[q.id] = ans.map((item) => ({
            option: {
              id: item.option.id,
              label: item.option.label,
            },
            percent: item.percent,
          }));
        }
      });

      setAnswers(formatted);
    }
  }, [questions, isPending]);
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  const getRiskConfig = (risk) => {
    switch (risk) {
      case "low":
        return {
          label: "Low Risk",
          className: "bg-emerald-50 text-emerald-700 border-emerald-200",
          icon: "check_circle",
        };
      case "medium":
        return {
          label: "Medium Risk",
          className: "bg-amber-50 text-amber-700 border-amber-200",
          icon: "warning",
        };
      case "high":
        return {
          label: "High Risk",
          className: "bg-red-50 text-red-700 border-red-200",
          icon: "dangerous",
        };
      case "low_medium":
        return {
          label: "Low To Medium Risk",
          className: "bg-amber-50 text-amber-700 border-amber-200",
          icon: "warning",
        };
      case "medium_high":
        return {
          label: "Medium to High Risk",
          className: "bg-red-50 text-red-700 border-red-200",
          icon: "dangerous",
        };
      case "not_scored":
      default:
        return {
          label: "Not Scored",
          className: "bg-slate-50 text-slate-600 border-slate-200",
          icon: "help",
        };
    }
  };
  return (
    <div className="relative p-4 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen">
      {/* LOADING OVERLAY */}
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/40 z-[999] backdrop-blur-sm">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {/* HEADER */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
        {/* TITLE + OVERALL RISK (INLINE) */}
        <div className="flex items-center gap-4 flex-wrap">
          {/* ICON */}
          <div className="p-2 rounded-xl bg-[#375AE7]/10 text-[#375AE7]">
            <span className="material-symbols-outlined">fact_check</span>
          </div>

          {/* TITLE */}
          <div>
            <h1 className="text-lg md:text-xl font-semibold text-slate-800 flex items-center gap-2">
              {heading}

              <span
                className={`material-symbols-outlined text-lg ${
                  isPending ? "text-amber-500" : "text-emerald-500"
                }`}
              >
                {isPending ? "schedule" : "verified"}
              </span>
            </h1>

            <p className="text-xs text-slate-500">
              {isPending ? "Pending Review" : "Completed Successfully"}
            </p>
          </div>

          {/* 🔥 OVERALL RISK BADGE (PROMINENT INLINE) */}
          {overallRisk && (
            <div className="ml-2 flex items-center gap-3 px-4 py-3 rounded-2xl border shadow-md bg-white/80 backdrop-blur-md relative overflow-hidden">
              {/* subtle risk glow background */}
              <div
                className={`absolute inset-0 opacity-10 ${
                  overallRisk === "high"
                    ? "bg-red-500"
                    : overallRisk === "medium"
                      ? "bg-amber-500"
                      : overallRisk === "low"
                        ? "bg-emerald-500"
                        : "bg-slate-400"
                }`}
              />

              {/* LEFT: LABEL */}
              <div className="flex flex-col leading-tight relative">
                <span className="text-[11px] uppercase tracking-wide text-slate-900">
                  Overall Risk Score
                </span>
              </div>

              {/* DIVIDER */}
              <div className="w-px h-8 bg-slate-200 relative" />

              {/* RIGHT: BADGE */}
              {(() => {
                const cfg = getRiskConfig(overallRisk);

                return (
                  <div className="flex items-center gap-2 relative">
                    {/* icon bubble */}
                    <div
                      className={`w-8 h-8 flex items-center justify-center rounded-full ${cfg.className}`}
                    >
                      <span className="material-symbols-outlined text-sm">
                        {cfg.icon}
                      </span>
                    </div>

                    {/* text */}
                    <div className="flex flex-col leading-tight">
                      <span className="text-sm font-semibold text-slate-800">
                        {cfg.label}
                      </span>

                      <span className="text-[11px] text-slate-500">
                        Auto-calculated from responses
                      </span>
                    </div>
                  </div>
                );
              })()}
            </div>
          )}
        </div>

        {/* ACTION BUTTON */}
        {!isPending && (
          <button
            onClick={() => setIsConfirmVerify(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#375AE7] text-white shadow-sm hover:bg-[#2f4bd3] transition"
          >
            <span className="material-symbols-outlined text-lg">shield</span>
            AML/CTF Program
          </button>
        )}
      </div>
      {/* INFO CARD (PENDING ONLY) */}
      {isPending && (
        <div className="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm mb-6 space-y-4">
          <div className="flex gap-3">
            <div className="p-2 rounded-lg bg-[#375AE7]/10 text-[#375AE7]">
              <span className="material-symbols-outlined">security</span>
            </div>

            <div>
              <h3 className="font-semibold text-slate-800">
                Additional Verification Required
              </h3>
              <p className="text-xs text-slate-500">
                To ensure compliance and account safety
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-3 text-xs text-slate-600">
            <div className="p-3 rounded-xl bg-slate-50 border border-slate-100">
              ✔ Identity verification if mismatch occurs
              <br />✔ Risk-based regulatory checks
            </div>
            <div className="p-3 rounded-xl bg-slate-50 border border-slate-100">
              ✔ Source of funds validation
              <br />✔ Ownership clarity checks
            </div>
          </div>
        </div>
      )}

      {/* QUESTIONS WRAPPER */}
      <form className="space-y-5">
        {questions.map((q, index) => (
          <div
            key={q.id}
            className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm hover:shadow-md transition"
          >
            {/* QUESTION HEADER */}
            <div className="flex items-start justify-between mb-3">
              <p className="text-sm font-medium text-slate-800 flex items-center gap-2">
                <div className="min-w-[36px] h-[36px] flex items-center justify-center rounded-xl bg-[#EEF2FF] text-[#375AE7] font-semibold text-sm">
                  {String(index + 1).padStart(2, "0")}
                </div>
                {q.question}
              </p>
              {q.answer?.risk_status && (
                <div
                  className={`flex items-center gap-1 px-2 py-1 rounded-full border text-[11px] font-medium ${
                    getRiskConfig(q.answer.risk_status).className
                  }`}
                >
                  <span className="material-symbols-outlined text-[14px]">
                    {getRiskConfig(q.answer.risk_status).icon}
                  </span>
                  {getRiskConfig(q.answer.risk_status).label}
                </div>
              )}
            </div>

            {/* TEXT INPUT */}
            {q.type?.value === 1 && (
              <input
                type="text"
                value={answers[q.id] || ""}
                disabled={roleName == "agent" || !isPending}
                onChange={(e) =>
                  setAnswers({ ...answers, [q.id]: e.target.value })
                }
                className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm focus:ring-2 focus:ring-[#375AE7]/30 outline-none"
                placeholder="Type your answer..."
              />
            )}

            {/* RADIO */}
            {q.type?.value === 2 &&
              q.options.map((opt, i) => (
                <label
                  key={i}
                  className="flex items-center gap-2 p-2 rounded-lg hover:bg-slate-50 cursor-pointer"
                >
                  <input
                    type="radio"
                    checked={answers[q.id] === opt.value}
                    disabled={roleName == "agent" || !isPending}
                    onChange={() => handleRadioChange(q.id, opt.value)}
                    className="accent-[#375AE7]"
                  />
                  <span className="text-sm text-slate-700">{opt.label}</span>
                </label>
              ))}
            {q.type?.value === 3 && (
              <Dropdown
                label=""
                options={q.options}
                onSelect={(value) => handleSelectChange(q.id, value)}
                preselectedValue={answers[q.id]}
                disabled={roleName == "agent" || !isPending}
              />
            )}
            {q.type?.value === 4 &&
              q.options.map((opt, i) => {
                const userOpt = (answers[q.id] || []).find(
                  (a) => a.id === opt.id,
                );

                return (
                  <div
                    key={opt.id}
                    className="flex items-center  text-sm gap-3 mb-2"
                  >
                    <input
                      type="checkbox"
                      id={`checkbox-${q.id}-${opt.id}`}
                      disabled={roleName == "agent" || !isPending}
                      checked={userOpt?.checked || false}
                      onChange={(e) =>
                        handleCheckboxWithPercentChange(
                          q.id,
                          opt.id,
                          "checked",
                          e.target.checked,
                        )
                      }
                      className="border-2 border-[#FF5050] accent-[#375AE7] rounded h-4 w-4 cursor-pointer"
                    />

                    <label
                      htmlFor={`checkbox-${q.id}-${opt.id}`}
                      className="flex-1 cursor-pointer"
                    >
                      {opt.label}
                    </label>

                    <div className="relative w-24">
                      <input
                        type="text"
                        placeholder="10.00"
                        value={userOpt?.percent || ""}
                        disabled={
                          !userOpt?.checked || roleName == "agent" || !isPending
                        }
                        onChange={(e) => {
                          const value = e.target.value;

                          if (/^\d*\.?\d*$/.test(value)) {
                            handleCheckboxWithPercentChange(
                              q.id,
                              opt.id,
                              "percent",
                              value,
                            );
                          }
                        }}
                        onBlur={(e) => {
                          const raw = e.target.value;

                          if (raw === "" || raw === ".") {
                            handleCheckboxWithPercentChange(
                              q.id,
                              opt.id,
                              "percent",
                              "",
                            );
                            return;
                          }

                          const formatted = parseFloat(raw).toFixed(2);

                          handleCheckboxWithPercentChange(
                            q.id,
                            opt.id,
                            "percent",
                            formatted,
                          );
                        }}
                        className={`w-full pr-5 border rounded px-2 py-1 text-right ${
                          !userOpt?.checked ? "bg-gray-100" : ""
                        }`}
                      />

                      <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500">
                        %
                      </span>
                    </div>
                  </div>
                );
              })}
            {/* CHECKBOX */}
            {(q.type?.value === 5 || q.type?.value === 6) &&
              (q.options || []).map((opt, i) => (
                <label
                  key={i}
                  className="flex items-center gap-2 p-2 rounded-lg hover:bg-slate-50 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    disabled={roleName == "agent" || !isPending}
                    checked={(answers[q.id] || []).includes(opt.value)}
                    onChange={() => handleCheckboxChange(q.id, opt.value)}
                    className="accent-[#375AE7]"
                  />
                  <span className="text-sm text-slate-700">{opt.label}</span>
                </label>
              ))}
            {q.type?.value === 9 && isPending && (
              <CountryPercentageField
                value={answers[q.id] || []}
                onChange={(val) => handleSelectChange(q.id, val)}
                disabled={roleName === "agent" || !isPending}
              />
            )}
            {q.type?.value === 9 && !isPending && (
              <div className="space-y-2">
                {(answers[q.id] || []).map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center border rounded-lg px-3 py-2 bg-gray-50"
                  >
                    <div className="text-sm text-gray-700">
                      {item.option?.label}
                    </div>

                    <div className="text-sm font-medium text-gray-900">
                      {item.percent}%
                    </div>
                  </div>
                ))}

                {/* TOTAL */}
                <div className="text-xs text-gray-500 text-right">
                  Total:{" "}
                  {(answers[q.id] || []).reduce(
                    (sum, i) => sum + Number(i.percent || 0),
                    0,
                  )}
                  %
                </div>
              </div>
            )}
          </div>
        ))}
      </form>
      {isConfirmVerify && (
        <AMLContent
          onClose={() => setIsConfirmVerify(false)}
          responses={responsesForAML}
        />
      )}
      {/* FOOTER ACTIONS (STICKY MODERN BAR) */}
      {isPending && (
        <div className="fixed bottom-0 left-0 w-full bg-white border-t border-slate-200 p-3 flex justify-between items-center shadow-lg">
          <button
            onClick={(e) => {
              e.preventDefault();
              if (!validateAnswers()) return; // stop submission if validation fails
              setLoading(true);
              handleSubmit();
            }}
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-[#375AE7] text-white"
          >
            <span className="material-symbols-outlined text-lg">send</span>
            Submit
          </button>

          {roleName === "agency" && userStatus === "active" && (
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2 px-4 py-2 rounded-xl border border-slate-300 text-slate-700"
            >
              <span className="material-symbols-outlined text-lg">
                dashboard
              </span>
              Dashboard
            </button>
          )}
        </div>
      )}
    </div>
  );
}